// src/admin/RequireAdmin.jsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { isAdminAuthed } from "./auth";

export default function RequireAdmin({ children }) {
  const location = useLocation();

  if (!isAdminAuthed()) {
    return <Navigate to="/admin/login" state={{ from: location.pathname }} replace />;
  }

  return children;
}
